import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MainService, IResponse } from 'src/app/services/main.service';

@Injectable({
  providedIn: 'root'
})
export class PosService {
  constructor(private http: HttpClient, private ms: MainService) { }
  Get_ItemByBarCode(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/pos/Get_ItemByBarcode', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  SalesMaster(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/SavePosSalesMaster', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  HeldSalesMaster(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/HeldSalesMaster', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GenerateInvNo(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/GeneratePOSInvoiceNo', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetSalesByInvNo(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/GetSalesdetailsandMasterByInvNo', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetCustomerByCode(body) {
    return this.http.post(this.ms.baseUrl + '/services/api/v1/Get_CustomerByCode', body, {
      headers: this.ms.getHeader()
    })
      .pipe(map((response: IResponse) => {
        return response;
      }))
  }
  GetCustomer(body) {
    return this.http.post(this.ms.baseUrl + '/services/api/v1/Get_Customer', body, {
      headers: this.ms.getHeader()
    })
      .pipe(map((response: IResponse) => {
        return response;
      }))
  }
  CounterClose(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/CounterClose', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Generate_XReport(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Generate_XReport', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  Save_PosContacts(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Save_PosContacts', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  Get_Contact_byInvNo(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_ContactbyInvNo', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  PosPrivilegeAction_ByActionId(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/Get_PosPrivilegeAction_ByActionId', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  POSCashierId_ByPassword(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/Get_POSCashierId_ByPassword', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Get_POSContact_byMobileNo(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_POSContactbyMobileNo', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Get_Salesman(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/Get_Salesman', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Get_Nationality() {
    return this.http
      .get(this.ms.baseUrl + '/Loyalty/Get_Nationality', {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Get_HeldLookUp(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_HeldLookUp', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetPOSContactSearch(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_POSContactSearch', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetSalesHistoryByContacts(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_SalesHistoryByContacts', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }


  GetSalesInvNoList(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_SalesInvoiceList', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  GetPredefinedDiscount(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_POS_PredefinedDiscount', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Delete_Items(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Delete_Items', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Cancel_Bill(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/DeletePOSInvoiceNo', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  Get_MemberByCardNo_POS(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_MemberbyCardNo_POS', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  POS_Update_Member(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/POS_Update_Member', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  POS_Generate_CardNo() {
    return this.http
      .get(this.ms.baseUrl + '/services/api/v1/POS/POS_Generate_CardNo', {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  PredefinedHistory(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_PreDiscHistory', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }


  // -------------------------Ecom--------------------------------------

  SaveSalesOrder(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Save_POSSalesOrder', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetSalesOrderByStatus(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_SalesOrderByStatus', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetSalesOrderById(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/POS/Get_SalesOrderById', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  GetRidersByLoc(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/pos/Get_RidersByLocation', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  updateSalesOrderStatus(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/v1/pos/Update_POSSalesOrderByOrderNoList', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }


  Update_Ecom_Status(body) {
    // const param = { data: body, status: true };
    return this.http
      .post(this.ms.E_Commerce.WebhookUrl + `/services/api/v1/POS/update_status/${body.order_id}`, body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  ecom_Status_Update(orderId: string, action: string, description: string = 'iPOS') {
    const params = { order_id: orderId, action: action, description };
    this.Update_Ecom_Status(params).subscribe(res => {

    });
  }

  updateEcomStatus(data: any) {
    return this.http.post(this.ms.baseUrl + '/services/api/v1/pos/Update_POSSalesOrderByOrderNo', data, {
      headers: this.ms.getHeader()
    })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  // -------------------------Ecom--------------------------------------

  // ----------------------------------Foreign Currency----------------------------
  getForeignCurrency(body) {
    return this.http
      .post(this.ms.baseUrl + "/services/api/v1/Get_CurrencyMasterList", body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  //------------------------Serial Number-------------------------
  getSerialNumberByBarcode(body) {
    return this.http
      .post(this.ms.baseUrl + "/services/api/v1/Get_SerialNumberByBarcode", body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

}
